<h1 mat-dialog-title class="editHeader text-center blueHeader dialogHeader text-white">{{headerTitle}}</h1>
<mat-dialog-content class="mb-4">
  <div class="row mt-3 col-md-12">
    
    <div class="col-md-6 mb-1">
      <label for="firstName" class="payingClinic col-md-6 text-bold">First Name</label>
      <input type="text" class="form-control input-font name inputBox col-md-6" id="firstName" [(ngModel)]="firstName">
    </div>
    <div class="col-md-6 mb-1">
      <label for="lastName" class="payingClinic col-md-6 text-bold">Last Name</label>
      <input type="text" class="form-control input-font name inputBox col-md-6" id="lastName" [(ngModel)]="lastName">
    </div>
    <div class="col-md-6 mb-1">
      <label for="clinicName" class="payingClinic col-md-6 text-bold">Clinic Name</label>
      <input type="text" class="form-control input-font name inputBox col-md-6" id="clinicName"
        [(ngModel)]="clinicName">
    </div>
    <div class="col-md-6 mb-1">
      <label for="emailId" class="payingClinic col-md-6 text-bold">EmailId</label>
      <input type="text" class="form-control input-font name inputBox col-md-6" id="emailId" [(ngModel)]="emailId">
    </div>
    <div class="col-md-6 mb-1">
      <label for="qualification" class="payingClinic col-md-6 text-bold">Qualification</label>
      <input type="text" class="form-control input-font name inputBox col-md-6" id="qualification"
        [(ngModel)]="qualification">
    </div>
    
    <div class="col-md-6 mb-1">
      <label for="keySkills" class="payingClinic col-md-6 text-bold">Key Skills</label>
      <input type="text" class="form-control input-font name inputBox col-md-6" id="keySkills" [(ngModel)]="keySkills">
    </div>
    <div class="col-md-6 mb-1">
      <label for="mobileNumber" class="payingClinic col-md-6 text-bold">MobileNumber</label>
      <input type="tel" class="form-control input-font name inputBox col-md-6" id="mobileNumber"
        [(ngModel)]="mobileNumber">
    </div>
    <div class="col-md-6 mb-1">
      <label for="addressLine1" class="payingClinic col-md-6 text-bold">Address Line 1</label>
      <input type="text" class="form-control input-font name inputBox col-md-6" id="addressLine1"
        [(ngModel)]="addressLine1">
    </div>
    <div class="col-md-6 mb-1">
      <label for="addressLine2" class="toPay col-md-6 text-bold">Address Line 2</label>
      <input type="text" class="form-control input-font price inputBox col-md-6" id="addressLine2"
        [(ngModel)]="addressLine2">
    </div>
    <div class="col-md-6 mb-1">
      <label for="city" class="toPay col-md-6 text-bold">City</label>
      <input type="text" class="form-control input-font qty inputBox col-md-6" id="city" [(ngModel)]="city">
    </div>
    <div class="col-md-6 mb-1">
      <label for="state" class="toPay col-md-6 text-bold">State</label>
      <input type="text" class="form-control input-font qty inputBox col-md-6" id="state" [(ngModel)]="state">
    </div>
    <div class="col-md-6 mb-1">
      <label for="pincode" class="toPay col-md-6 text-bold">Pincode</label>
      <input type="text" class="form-control input-font qty inputBox col-md-6" id="pincode" [(ngModel)]="pincode">
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row col-md-12 justify-content-md-center">
    <button mat-button class="mat-raised-button btnWidth  mr-4 btn blankTurquoise"
    (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="updateItem()">Update</button>

  </div>
</mat-dialog-actions>
